import { categoryLabel } from './incidentLabels';

interface IncidentCategoryChipProps {
  category: string;
}

export const IncidentCategoryChip = ({ category }: IncidentCategoryChipProps) => (
  <span className="text-sm text-zinc-900">{categoryLabel(category)}</span>
);
